import styled from 'styled-components';

export const ConfigAuditHistoryWrapper = styled.div`
    padding: 10px 5px 0;
    height: 100%;
    display: flex;
    flex-direction: column;
`;
